import type React from 'react';

import { useStepExternalInvitations } from '@/hooks/createSix/useStepExternalInvitations';
import ExternalInvitationStep from '@/components/organism/CreateSix/steps/StepExternal/ExternalInvitationStep';

export interface StepExternalInvitationsProps {
  onClose: () => void;
}

export function StepExternalInvitations(props: StepExternalInvitationsProps): React.JSX.Element {
  void props;

  const { state, handlers } = useStepExternalInvitations();

  return (
    <ExternalInvitationStep
      activeTab={state.activeTabValue}
      onTabChange={handlers.handleTabChange}
      contactsSearchValue={state.contactsSearchValue}
      onContactsSearchValueChange={handlers.handleContactsSearchValueChange}
      contactRows={state.contactRows}
      onAddContact={handlers.handleAddContact}
      selectedParticipants={state.selectedParticipants}
      onRemoveSelectedParticipant={handlers.handleRemoveSelectedParticipant}
      manualRows={state.manualRows}
      onManualRowValuesChange={handlers.handleManualRowValuesChange}
      onAddManualRow={handlers.handleAddManualRow}
      onRemoveManualRow={handlers.handleRemoveManualRow}
      onAddRowToSix={handlers.handleAddRowToSix}
    />
  );
}

StepExternalInvitations.displayName = 'StepExternalInvitations';

export default StepExternalInvitations;
